//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import mdAutocomplete from '../../../../../shared-components/autocomplete/mdAutocomplete';
import workspaceMixin from '../../../../../common/functions/workspace-filtros';
import {
  prepareResponseData,
  removeParametrosNulos,
} from '../../../../../common/functions/http';

export default {
  mixins: [workspaceMixin],
  props: {
    filtro: Object,
    mdOpenFrom: String,
    entidade: '',
  },
  data() {
    return {
      acordoResources: this.$api.acordo(this.$resource),
      tipoInvestimentoResources: this.$api.tipoInvestimento(this.$resource),
      dashboardNegociacaoResources: this.$api.dashboardNegociacao(this.$resource),
      dashboardApuracaoResources: this.$api.dashboardApuracao(this.$resource),
      clienteResources: this.$api.cliente(this.$resource),
      produtoResources: this.$api.produto(this.$resource),
      statusBloqueado: true,
      statusApuracao: [
        { status: 'AGUARDANDO_APROVACAO', descricao: this.$t('status_entidade.aguardando_aprovacao') },
        { status: 'APROVADO', descricao: this.$tc('status_entidade.aprovado', 1) },
        { status: 'REPROVADO', descricao: this.$tc('status_entidade.reprovado', 1) },
        { status: 'CANCELADO', descricao: this.$t('label.cancelado') },
        { status: 'EM_ANALISE', descricao: this.$t('status_entidade.em_analise') }],
    };
  },
  computed: {
  },
  components: {
    mdAutocomplete,
  },
  methods: {
    prepareResponseData,
    setMarca(hit) {
      this.filtro.idMarca = hit.id;
    },
    setTipoLinhaOrcamento(hit) {
      this.filtro.idTipoLinhaOrcamento = hit.id;
    },
    setLinhaProduto(hit) {
      this.filtro.idLinhaProduto = hit.id;
    },
    setFamilia(hit) {
      this.filtro.idFamilia = hit.id;
    },
    setProduto(hit) {
      this.filtro.idProduto = hit.id;
    },
    setCliente(hit) {
      this.filtro.idCliente = hit.id;
    },
    setTipoAcordo(hit) {
      this.filtro.idTipoAcordo = hit.id;
    },
    setSolicitante(hit) {
      this.filtro.idSolicitante = hit.id;
    },
    limparMarca() {
      this.filtro.idMarca = null;
    },
    limparTipoLinhaOrcamento() {
      this.filtro.idTipoLinhaOrcamento = null;
    },
    limparLinhaProduto() {
      this.filtro.idLinhaProduto = null;
    },
    limparFamilia() {
      this.filtro.idFamilia = null;
    },
    limparProduto() {
      this.filtro.idProduto = null;
    },
    limparCliente() {
      this.filtro.idCliente = null;
    },
    limparTipoAcordo() {
      this.filtro.idTipoAcordo = null;
    },
    limparSolicitante() {
      this.filtro.idSolicitante = null;
    },
    verificarMeuPassoPendente() {
      this.filtro.meuPassoPendente = !this.filtro.meuPassoPendente;
      if (this.filtro.meuPassoPendente) {
        this.filtro.status = 'AGUARDANDO_APROVACAO';
        this.statusBloqueado = true;
        this.filtro.meuPassoAprovado = false;
      } else {
        this.statusBloqueado = false;
      }
    },
    verificarMeuPassoAprovado() {
      this.filtro.meuPassoAprovado = !this.filtro.meuPassoAprovado;
      if (this.filtro.meuPassoAprovado) {
        // this.filtro.status = '';
        this.statusBloqueado = true;
        this.filtro.meuPassoPendente = false;
      } else {
        this.statusBloqueado = false;
      }
    },
    open() {
      this.$refs.modal.open();
      this.onOpen();
    },
    defaultClose() {
      this.$emit('GENERICMODAL_DEFAULT_CLOSE');
      this.close();
    },
    onOpen() {
      this.$emit('GENERICMODAL_OPEN');
    },
    onClose() {
      this.$emit('GENERICMODAL_CLOSE');
    },
    close() {
      this.$refs.modal.close();
      this.onClose();
    },
    filtrar() {
      const copiaFiltro = Object.assign({}, this.filtro);
      removeParametrosNulos(copiaFiltro);
      copiaFiltro.meuPassoPendente = this.filtro.meuPassoPendente;
      copiaFiltro.meuPassoAprovado = this.filtro.meuPassoAprovado;
      this.salvarWorkspace(this.entidade, copiaFiltro);
      this.$emit('FILTROSDASH_FILTRAR', copiaFiltro);
      this.defaultClose();
    },
    preencherFiltros(filtros) {
      this.filtro.status = filtros.status;
      this.filtro.solicitante = filtros.solicitante || '';
      this.filtro.tipoAcordo = filtros.tipoAcordo || '';
      this.filtro.tipoLinhaOrcamento = filtros.tipoLinhaOrcamento || '';
      this.filtro.marca = filtros.marca || '';
      this.filtro.linhaProduto = filtros.linhaProduto || '';
      this.filtro.familia = filtros.familia || '';
      this.filtro.produto = filtros.produto || '';
      this.filtro.cliente = filtros.cliente || '';

      this.filtro.idMarca = filtros.idMarca;
      this.filtro.idTipoLinhaOrcamento = filtros.idTipoLinhaOrcamento;
      this.filtro.idLinhaProduto = filtros.idLinhaProduto;
      this.filtro.idFamilia = filtros.idFamilia;
      this.filtro.idProduto = filtros.idProduto;
      this.filtro.idCliente = filtros.idCliente;
      this.filtro.idTipoAcordo = filtros.idTipoAcordo;
      this.filtro.idSolicitante = filtros.idSolicitante;
      this.filtro.idAcordo = filtros.idAcordo;

      this.filtro.meuPassoPendente = !!filtros.meuPassoPendente;
      this.filtro.meuPassoAprovado = !!filtros.meuPassoAprovado;
      this.statusBloqueado = !!(this.filtro.meuPassoPendente || this.filtro.meuPassoAprovado);
      this.$forceUpdate();
    },
  },
  mounted() {
    this.carregarWorkspace(this.entidade, this.preencherFiltros)
      .then(() => this.filtrar());
  },
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/spa/dashboard/cadeia/FiltrosDash.vue?vue&type=script&lang=js&